module.exports = __webpack_public_path__ + "static/media/offerteaanvaard_color.9e658088.svg";